import makeStyles from '@mui/styles/makeStyles';

export const useSessionStyles = makeStyles((theme) => ({
    contentStyle: {
        borderTop: '1px solid #494B4C',
        minHeight: '50vh',
        // height: 'max-content',
    },
    patientListContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 15,
        height: '100%',
    },
    patientBox: {
        display: 'flex',
        alignItems: 'center',
        padding: '5px 10px',
        gap: 15,
        borderRadius: 8,
        backgroundColor: theme.palette.background.paperDarker,
    },
    ptName: {
        textTransform: 'uppercase',
        fontWeight: 'bold',
    },
    gender: {
        marginRight: 8,
        borderRadius: 6,
        color: '#222425',
        display: 'flex',
        justifyContent: 'center',
        padding: 2,
        '&.Male': {
            backgroundColor: '#92bfe2',
        },
        '&.Female': {
            backgroundColor: '#f4bdd1',
        },
        '&.Unspecified': {
            backgroundColor: '#999999',
        },
    },
    age: {
        color: '#ACAFB3',
        fontSize: 12,
        '&.dncpr': {
            color: '#FFFFFF',
        },
    },
    spaceBetween: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    fullRow: {
        display: 'flex',
        flexDirection: 'column',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    gRow: {
        flexGrow: 1,
        maxWidth: 250,

        '&.small': {
            maxWidth: 150,
        },
        '&.medium': {
            maxWidth: 200,
        },
    },
    dncpr: {
        backgroundColor: '#E25B61',
        borderRadius: 6,
        padding: 5,
    },
    actionStyle: {
        paddingRight: 14,
        paddingBottom: 14,
    },
    selectedAttendanceBox: {
        backgroundColor: '#fff',
        color: '#000',
        borderRadius: 6,
        padding: 10,
        margin: 10,
    },
    selectedAttendanceBoxLine: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    attendanceListBox: {
        maxHeight: '25vh',
        width: '100%',
        marginBottom: 10,
        paddingLeft: 10,
    },
    attendanceListItem: {
        height: 70,
        padding: 10,
        border: '1px solid #494B4C',
        borderRadius: 6,
        marginRight: 5,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        '&:hover': {
            backgroundColor: theme.palette.background.paperDarker,
            cursor: 'pointer',
        },
        '&.selected': {
            backgroundColor: theme.palette.background.paperDarker,
        },
    },
    chipOverride: {
        color: theme.palette.designSystem.palette.text1,
        backgroundColor: 'transparent',
    },
    chipBackground: {
        backgroundColor: 'transparent',
    },
    selectTypeBox: {
        marginLeft: 10,
        marginTop: 5,
        display: 'flex',
        alignItems: 'center',
        gap: 5,
    },
}));